module.exports = __webpack_public_path__ + "static/media/galerija_2019 (37).baab79a2.jpg";